import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import History, { TransactionStatus, TransactionType, CancelStatus } from '@models/user/history/History';
import IHistoryDto from '@core/mappers/user/dtos/IHistoryDto';

const TRANSACTION_WON_CLASS = 'green';
const CASINO_TRANSACTION_STATUS = 'Finished';

const getType = (dto: IHistoryDto) => {
    const name = dto.transactionName;
    if (name.indexOf('Retragere') === 0) {
        return TransactionType.withdrawal;
    }
    if (name.indexOf('Ajustare') === 0) {
        return TransactionType.manual;
    }
    if (name.indexOf('Depunere') === 0) {
        return TransactionType.deposit;
    }
    return TransactionType.other;
};

export default class HistoryMapper extends AbstractMapper<IHistoryDto, History> {
    createTargetObject(dto: IHistoryDto, key: number): History {
        const history = {} as History;
        history.id = dto.transactionIdSec;
        history.date = this.toDate(dto.dateTime, { assumeUtc: true }) as Date;
        history.amount = dto.diff;
        // only casino transactions can be 'Finished'
        if (dto.status === CASINO_TRANSACTION_STATUS) {
            if (dto.colorClass === TRANSACTION_WON_CLASS) {
                history.status = TransactionStatus.won;
            } else {
                history.status = TransactionStatus.lost;
            }
        } else {
            history.status = dto.status as TransactionStatus;
        }
        history.isCancelable = dto.cancelTransaction;
        history.title = dto.transactionName;
        history.ticketId = dto.ticketId || '';
        history.type = getType(dto);
        history.cancelStatus = CancelStatus.none;
        return history;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/user/HistoryMapper.ts